import React from 'react'

const Footer = () => {
  return (
    <div  name='footer' className=' bg-gradient-to-b from-black to-gray-800 p-4 text-white'>
        <div className='flex justify-center max-w-screen-lg mx-auto  h-full'>
            <div className=''>
                <p className='font-medium text-gray-300'>&#169; Onyewuchi Emeka Manuel. 2022</p>
            </div>
        </div>
    </div>
  )
}

export default Footer